var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: 1,
    attrs: {
      tab: _vm.$t("客户基本信息")
    }
  }, [_c("customer-model", {
    attrs: {
      id: _vm.id
    },
    on: {
      ok: _vm.handleOk
    }
  })], 1), _c("a-tab-pane", {
    key: 2,
    attrs: {
      tab: _vm.$t("操作权限")
    }
  }, [_c("authority", {
    attrs: {
      type: "customer",
      id: _vm.id
    },
    on: {
      ok: _vm.authorityOk
    }
  })], 1), _vm.isCustomPage ? _c("a-tab-pane", {
    key: 3,
    attrs: {
      tab: _vm.$t("自定义模版")
    }
  }, [_c("custom-page", {
    attrs: {
      id: _vm.id,
      permission: _vm.permission
    },
    on: {
      back: _vm.backFun
    }
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };